import { types, flow } from 'mobx-state-tree';
import moment from 'moment';
import _ from 'lodash';
import {
  query,
  mutate,
} from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import approveReservationM from './approveReservationMFn';
import confirmQL from './confirmQL';
import getReservationConfirmationsQ from './getReservationConfirmations.Q';
import denyReservationMFn from './denyReservationMFn';
import { addTime } from '../../helpers/timeFormatHelpers';
import { trackApproval, trackDeny } from '../../core/analytics';
import { addressModel } from '../../components_new/addresses/AddressStore';

export default types
  .model('ReservationItemModel', {
    total: 0,
    pickupAddress: types.optional(addressModel, { id: -1 }),
    returnAddress: types.optional(addressModel, { id: -2 }),
    timezone: '',
    pickupTime: '',
    returnTime: '',
    pickupDay: '',
    returnDay: '',
    ownerPickupTime: '',
    ownerDropoffTime: '',
    guestPickupTime: '',
    guestDropoffTime: '',
    pickupCompleted: false,
    returnCompleted: false,
    pickupDate: '',
    returnDate: '',
    checkIn: '',
    checkOut: '',
    termsAccepted: false,
    pickupLat: '',
    pickupLng: '',
    returnLat: '',
    returnLng: '',
    confirmationStep: '',
    isPickup: true,
    confirmationPollingId: 0,
  })
  .actions(self => ({
    // RESERVATION APPROVE ? DENY
    approve: flow(function*() {
      const approveParams = {
        pickupTime: self.pickupTime,
        returnTime: self.returnTime,
        pickupDay: self.pickupDay,
        returnDay: self.returnDay,
        pickupAddress: self.pickupAddress,
        returnAddress: self.returnAddress,
        id: self.reservationId,
        threadId: self.threadId,
      };
      trackApproval(self.total, self.units, self.category);
      // console.log('approveParams', approveParams);
      return approveReservationM(approveParams);
    }),
    deny: flow(function*() {
      trackDeny(self.total, self.units, self.category);
      const isSuccess = yield denyReservationMFn({
        id: self.reservationId,
        threadId: self.threadId,
      });
      return isSuccess;
    }),

    updatePickupDay: val => {
      self.pickupDay = val;
    },
    updateReturnDay: val => {
      self.returnDay = val;
    },
    updatePickupTime: val => {
      self.pickupTime = val;
    },
    updateReturnTime: val => {
      self.returnTime = val;
    },
    // EXCHANGES/CONFIRMATIONS
    acceptTerms() {
      self.termsAccepted = !self.termsAccepted;
    },
    setStep(newStep) {
      self.confirmationStep = newStep;
    },
    finishExchange() {
      self.setStep('initial');
    },
    setExchangeCompleteHandler(handler) {},
    confirm: flow(function*(lat, lng) {
      if (!self.pickupCompleted) {
        self.pickupLat = lat;
        self.pickupLng = lng;
      } else {
        self.returnLat = lat;
        self.returnLng = lng;
      }
      const variables = {
        reservationId: self.reservationId,
        lat: lat || 0.0,
        lng: lng || 0.0,
      };
      variables[self.confirmationStage] = true;
      console.log('confirmation variables', variables);
      this.error = 'Confirming...';
      try {
        const res = yield mutate(confirmQL, variables);
        // self.error = 'Confirmed...' + JSON.stringify(res);
        console.log('Exchange Modal - res', res);
        if (getp(res, 'data.updateExchange.status') === 200) {
          self.setStep('confirmed');
        } else {
          return false;
        }
        return res;
      } catch (e) {
        self.error = `Error modifying confirmation: ${e}`;
        console.log('Error modifying confirmation: ', e);
      }
    }),
    startConfirmationWatch() {
      self.confirmationPollingId = setInterval(
        self.checkForConfirmations,
        6000,
      );
    },
    stopConfirmationWatch() {
      clearInterval(self.confirmationPollingId);
      self.confirmationPollingId = 0;
    },
    checkForConfirmations: async completeExchange => {
      const id = self.reservationId;
      try {
        const updates = await query(getReservationConfirmationsQ, {
          id,
        });
        const valid = getp(updates, 'data.getReservation.id');
        if (valid) {
          console.log('updates', updates);
          const isFinalDropoff = self.updateTimes(
            getp(updates, 'data.getReservation'),
          );
          return isFinalDropoff;
        }
      } catch (e) {
        console.log('ERROR: failed to get confirmation data', e);
      }
    },
    updateTimes(newTimes) {
      self.ownerPickupTime = newTimes.ownerPickupTime || '';
      self.ownerDropoffTime = newTimes.ownerDropoffTime || '';
      self.guestPickupTime = newTimes.guestPickupTime || '';
      self.guestDropoffTime = newTimes.guestDropoffTime || '';
      if (self.isPickup && self.ownerPickupTime && self.guestPickupTime) {
        self.pickupCompleted = true;
        this.setStep('review');
        return false;
      } else if (self.guestDropoffTime && self.ownerDropoffTime) {
        self.returnCompleted = true;
        return true;
      }
    },
  }))
  .views(self => ({
    get confirmationStage() {
      const str = self.isHost ? 'owner' : 'renter';
      return str.concat(!self.pickupCompleted ? 'Pickup' : 'Return');
    },
    get exchangeStage() {
      return self.isPickup ? 'Pickup' : 'Return';
    },
    get pickupDayFormatted() {
      return this.checkIn && moment(this.checkIn).format('dddd MMMM Do');
    },

    get returnDayFormatted() {
      return this.checkOut && moment(this.checkOut).format('dddd MMMM Do');
    },
    get isInvalid() {
      return !self.pickupTime || !self.returnTime;
    },
    get exchangeCompleted() {
      return self.pickupCompleted && self.returnCompleted;
    },

    get relationshipDescriptor() {
      if (self.reservationState === 'pending') {
        return (
          self.otherFirstName +
          (self.isHost ? ' wants your ' : "'s ") +
          self.title
        );
      }
      return self.title;
    },
    get nextAction() {
      if (self.isHost) {
        if (self.reservationState === 'pending') {
          return 'approve';
        }
      }
      return 'review';
    },
    get pickupDayReadable() {
      return moment
        .utc(self.pickupDay ? self.pickupDay : self.checkIn)
        .format('MMMM D, YYYY');
    },
    get returnDayReadable() {
      return moment
        .utc(self.returnDay ? self.returnDay : self.checkOut)
        .format('MMMM D, YYYY');
    },
    get pickupTimeReadable() {
      return self.pickupTime
        ? addTime(moment(), self.pickupTime).format('h:mm a')
        : '';
    },
    get returnTimeReadable() {
      console.log('self.returnTime', self.returnTime);
      return self.returnTime
        ? addTime(moment(), self.returnTime).format('h:mm a')
        : '';
    },
    get numDays() {
      return moment(self.returnDate).diff(self.pickupDate, 'days');
    },
    get pickupAddressStr() {
      const a = self;
      if (a.pickupAddress.street.value) {
        return `${a.pickupAddress.street.value} ${
          a.pickupAddress.buildingName.value ? `${a.pickupAddress.buildingName.value} ` : ''
        }${a.pickupAddress.city.value}, ${a.pickupAddress.state.value} ${
          a.pickupAddress.zipcode.value
        }`;
      }
    },
    get pickupAddress1Str() {
      const a = self;
      if (a) {
        return `${a.pickupAddress.street.value} ${
          a.pickupAddress.buildingName.value ? `${a.pickupAddress.buildingName.value} ` : ''
        }`;
      }
    },
    get pickupAddress2Str() {
      const a = self;
      if (a) {
        return `${a.pickupAddress.city.value}, ${a.pickupAddress.state.value} ${
          a.pickupAddress.zipcode.value
        }`;
      }
    },
    get returnAddressStr() {
      const a = self;
      if (a.returnAddress.street.value) {
        return `${a.returnAddress.street.value} ${
          a.returnAddress.buildingName.value ? `${a.returnAddress.buildingName.value} ` : ''
        }${a.returnAddress.city.value}, ${a.returnAddress.state.value} ${
          a.returnAddress.zipcode.value
        }`;
      }
    },
    get returnAddress1Str() {
      const a = self;
      if (a) {
        return `${a.returnAddress.street.value} ${
          a.returnAddress.buildingName.value ? `${a.returnAddress.buildingName.value} ` : ''
        }`;
      }
    },
    get returnAddress2Str() {
      const a = self;
      if (a) {
        return `${a.returnAddress.city.value}, ${a.returnAddress.state.value} ${
          a.returnAddress.zipcode.value
        }`;
      }
    },
    get priceInfo() {
      if (
        ['pending', 'approved', 'completed'].indexOf(self.reservationState) >= 0
      ) {
        return `$${self.total}`;
      } else if (self.group === 'inquiry') {
        return 'Inquiry';
      }
      return (
        (self.reservationState &&
          self.reservationState[0].toUpperCase() +
            self.reservationState.substring(1)) ||
        'chillen'
      );
    },
  }));



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/ReservationItemModel.js